module.exports = __webpack_public_path__ + "static/img/survey-start.17d0fa54.svg";